<style>
@import '../../assets/css/register.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_user_downline')}}</template>
                            <b-form-input v-model="ajaxSearch.login"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('register_history.table_coin_id')}}</template>
                            <b-form-select v-model="ajaxSearch.coin_id">
                                <option value="">-</option>
                                <option v-for="(list,index) in ajaxToolList.coinList" :key="index" :value='list.name'>{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t('admin.table_all_package_history')" header-tag="header">
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="logPackage()" v-if="permissionList.includes(permission.packageLog)">{{$t('admin.table_package_log')}}</b-button>                                    
                            <b-button variant="primary" size="lg" @click="infoPackage()" v-if="permissionList.includes(permission.info)" class="ml-1">{{$t('admin.table_package_info')}}</b-button>                                    
                            <b-button variant="danger" size="lg" @click="recallEntrust()" v-if="permissionList.includes(permission.recall) && ajaxRecallable" class="ml-1">{{$t('admin.table_recall_entrust')}}</b-button>                                    
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
        <b-modal id="logPackage" :title="$t('admin.table_package_log')" hide-footer size="xl">
            <el-table class="custom-table" :data="ajaxTablePackageLog" ref="tableTestPackageLog" border>
                <el-table-column v-for="title in titlesPackageLog" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                </el-table-column>
            </el-table>
            <b-row class="mt-3">
                <b-col sm="12" md="3" class="pr-0">
                    <span class="float-left">{{$t('admin.table_show_result',{result:ajaxToolPackageLog.total_number})}}</span>
                </b-col>
                <b-col sm="12" md="9" class="pl-0">
                    <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChangePackageLog" @current-change="paginationCurrentChangePackageLog" :current-page.sync="ajaxToolPackageLog.current_pagination" :total="ajaxToolPackageLog.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="infoPackage" :title="$t('admin.table_package_info')" hide-footer size="xl">
            <b-row class="form-label">
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <label>{{ajaxInfo.id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label>{{ajaxInfo.code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <label>{{ajaxInfo.created_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_completed_at')}}</template>
                            <label>{{ajaxInfo.completed_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_valid_at')}}</template>
                            <label>{{ajaxInfo.valid_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_canceled_at')}}</template>
                            <label>{{ajaxInfo.canceled_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label>{{ajaxInfo.master_id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_coin')}}</template>
                            <label>{{ajaxInfo.coin_id}}</label>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_group_id')}}</template>
                            <label>{{ajaxInfo.group_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_capital')}}</template>
                            <label>{{ajaxInfo.capital}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_balance')}}</template>
                            <label>{{ajaxInfo.balance}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_stop_price')}}</template>
                            <label>{{ajaxInfo.stop_price}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_stop_rate')}}</template>
                            <label>{{ajaxInfo.stop_rate}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_price')}}</template>
                            <label>{{ajaxInfo.price}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <label>{{ajaxInfo.status}}</label>                                                        
                        </b-form-group>
                    </b-col>
                </b-row>
        </b-modal>
    </div>
</template>

<script>
import {historyAjaxTable,packageLog,packageInfo,entrustRecall} from '@/system/model/register';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxTablePackageLog:[],
            ajaxToolPackageLog:[],
            ajaxToolList:[],
            ajaxInfo:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',valid_at:'',completed_at:'',group_id:'',master_id:'',coin_id:'',price:'',capital:'',balance:'',total_usdt:'',is_active:'',login:''},
            ajaxSearchPackageLog:{limit:'',pagination:''},
            ajaxRow:'',
            pageLimit:10,
            permissionList:[],
            my_security_password:'',
            ajaxRecallable:'',
            permission:{
                packageLog:'862074',
                info:'A9904D',
                recall:'486D68',
            },
            titles:[{
                prop: "id",
                label: this.$t('register_history.table_id'),
                width:'108'
            },{
                prop: "created_at",
                label: this.$t('register_history.table_date'),
                width:'209'
            },{
                prop: "valid_at",
                label: this.$t('register_history.table_valid_at'),
                width:'209'
            },{
                prop: "completed_at",
                label: this.$t('admin.table_completed_at'),
                width:'209'
            },{
                prop: "group_id",
                label: this.$t('sidebar.tools.group'),
                width:'209'
            },{
                prop: "master_id",
                label: this.$t('register_history.table_user_id'),
                width:'209'
            },{
                prop: "coin_id",
                label: this.$t('register_history.table_coin_id'),
                width:'209'         
            },{
                prop: "price",
                label: this.$t('admin.table_price'),
                width:'209'                                 
            },{
                prop: "capital",
                label: this.$t('admin.table_capital'),
                width:'209'                                 
            },{
                prop: "balance",
                label: this.$t('register_history.table_amount'),
                width:'209'                                 
            },{
                prop: "total_usdt",
                label: this.$t('admin.table_usdt_amount'),
                width:'209'                                 
            },{
                prop: "is_active",
                label: this.$t('register_history.table_is_active'),
                width:'104'                                
            }], 
            titlesPackageLog:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'50'
            },{
                prop: "group_at",
                label: this.$t('admin.table_date'),
                width:'100'
            },{
                prop: "master_id",
                label: this.$t('admin.table_master_id'),
                width:'100'
            },{
                prop: "total_value",
                label: this.$t('admin.table_remark'),
                width:'100'
            },{
                prop: "rate",
                label: this.$t('admin.table_ip_address'),
                width:'60'
            }]      
        }
    },methods:{
        initialize(){
            var self = this;
            var result = historyAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.valid_at,this.ajaxSearch.completed_at,this.ajaxSearch.group_id,this.ajaxSearch.master_id,this.ajaxSearch.coin_id,this.ajaxSearch.price,this.ajaxSearch.capital,this.ajaxSearch.balance,this.ajaxSearch.total_usdt,this.ajaxSearch.is_active,this.ajaxSearch.login);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },logPackage(){
            if(this.permissionList.includes(this.permission.packageLog)){
                var self = this;
                var result = packageLog(this.ajaxRow,this.ajaxSearchPackageLog.limit,this.ajaxSearchPackageLog.pagination);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxTablePackageLog = value.data.datatable.data;
                        self.ajaxToolPackageLog = value.data.datatable;
                        self.csrfName = value.data.csrf_list.csrf_name;
                        self.csrfValue = value.data.csrf_list.csrf_value;
                        self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                        self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                        self.$bvModal.show('logPackage');
                    }
                });
            }
        },infoPackage(){
            if(this.permissionList.includes(this.permission.info)){
                var self = this;
                var result = packageInfo(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxInfo = value.data.investment_detail;
                        self.$bvModal.show('infoPackage');
                    }
                });
            }
        },recallEntrust(){
            if(this.permissionList.includes(this.permission.recall)){
                var self = this;
                this.$swal.fire({
                    text: this.$t('security.msg_my_security_password'),
                    input: 'password',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('button.cancel'),
                    showLoaderOnConfirm: false,
                    
                    preConfirm: (postData) => {
                        if(postData){
                            this.my_security_password = postData;
                            return true;
                        }else{
                            this.my_security_password = '';
                            this.submitButton = true;
                            this.preloader(false);
                            this.$swal.fire({
                                type: 'error',
                                text: this.$t('security.error_security_password_empty')
                            });
                                
                            return false;
                        }
                    },
                }).then((result)=>{
                    if(result.value) {
                        this.preloader(true);
                        var formData = new FormData();
                        formData.append('security', this.my_security_password);
                        formData.append('id', this.ajaxRow);
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 

                        var result = entrustRecall(formData);
                        
                        result.then(function(value){
                            self.preloader(false);
                            
                            if(value.valid){
                                self.preloader(true);
                                self.$swal.fire({
                                    type: 'success',
                                    html:  self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();
                                    }
                                });
                            }else{
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        location.reload();
                                    }
                                });
                                
                                self.submitButton = true;
                            }
                        });
                        
                    }else{
                        this.preloader(false);
                    }
                });
            }
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id,
            this.ajaxRecallable = row.recallable
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },paginationSizeChangePackageLog(limit){
            this.ajaxSearchPackageLog.limit = limit;
            this.logPackage();
        },paginationCurrentChangePackageLog(pagination){
            this.ajaxSearchPackageLog.pagination = pagination;
            this.logPackage();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
